import { Dispatch, GetFrontOfficeState } from '@lumapps/redux/types';

import { FetchBlockParams, getWidgetBlocks } from '../../api';
import { getFormattedWidgetFilterFetchParams } from '../../utils/getFormattedWidgetFilterFetchParams';
import { fetchWidgetBlocks } from './fetchWidgetBlocks';

export const fetchWidgetBlocksById =
    ({
        params: { ownerResourceInfo, ...params } = {},
        widgetId,
        widgetType,
        isMainWidget,
        skipErrorHandling,
    }: {
        params?: FetchBlockParams;
        widgetId: string;
        widgetType: string;
        isMainWidget: boolean;
        // This param is to let the query handle the error instead of the redux state
        skipErrorHandling?: boolean;
    }) =>
    async (dispatch: Dispatch, getState: GetFrontOfficeState) => {
        const currentState = getState();
        const filterFetchParams = getFormattedWidgetFilterFetchParams(currentState, params, widgetId);

        const fetchParams = {
            ownerResourceId: ownerResourceInfo?.ownerResourceId,
            ownerResourceType: ownerResourceInfo?.ownerResourceType,
            ...params,
            ...filterFetchParams,
        };

        return dispatch(
            fetchWidgetBlocks(
                widgetId,
                async (acceptLanguageHeader) => {
                    return getWidgetBlocks(widgetType, widgetId, fetchParams, acceptLanguageHeader);
                },
                fetchParams,
                isMainWidget,
                undefined,
                skipErrorHandling,
            ),
        );
    };
